<template>
  <transition name="fade">
    <v-footer
      color="transparent"
      class="d-flex justify-center align-center column-gap-4 pt-0 pb-4 text--x-small"
    >
      <app-button
        size="x-small"
        type="ghost"
        variant="neutral"
      >
        <AppDownloadFile :link="urlCGU" forceReader>
          <template #default="{ submitForm }">
            <span @click="submitForm">
              {{ $t('common.Footer.termsOfUse') }}
            </span>
          </template>
        </AppDownloadFile>
      </app-button>
      <app-button
        class="text-grey-700"
        :href="$t('common.Footer.trustCenterLink')"
        size="x-small"
        target="_blank"
        type="ghost"
        variant="neutral"
      >
        {{$t('common.Footer.trustCenter')}}
      </app-button>
      <app-button
        class="text-grey-700"
        :href="$t('common.Footer.helpUrl')"
        size="x-small"
        target="_blank"
        type="ghost"
        variant="neutral"
      >
        {{$t('common.Footer.help')}}
      </app-button>
    </v-footer>
  </transition>
</template>

<script>
import AppDownloadFile from './AppDownloadFile.vue'
/**
 * Default App footer
 * @displayName AppFooter
 */
/**
 * Default App footer
 */
export default {
  name: 'AppFooter',
  components: { AppDownloadFile },
  computed: {
    urlCGU () {
      return `${import.meta.env.VUE_APP_API_URL}/assets/pdf?file=terms-of-service-${this.$i18n.locale.toUpperCase()}`
    },
    closdVersion () {
      return __APP_VERSION__
    },
  },
}
</script>
